<template>
  <div :class="computedClasses">
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { ContainerSize } from './types'

const props = withDefaults(defineProps<{
  size?: ContainerSize
}>(), {
  size: '2xl',
})

const computedClasses = computed(() => [
  'mx-auto px-4 w-full',
  {
    'max-w-2xl': props.size === 'sm',
    'max-w-2xl sm:max-w-3xl': props.size === 'md',
    'max-w-2xl sm:max-w-3xl md:max-w-4xl': props.size === 'lg',
    'max-w-2xl sm:max-w-3xl md:max-w-4xl lg:max-w-5xl': props.size === 'xl',
    'max-w-2xl sm:max-w-3xl md:max-w-4xl lg:max-w-5xl xl:max-w-7xl': props.size === '2xl',
    'max-w-full': props.size === 'full',
  },
])
</script>
